const TRANSLATE_CUSTOM_LINE_ITEM = {
  'provider-flat-fee': {
    label: 'Platform fee',
  },
};

export { TRANSLATE_CUSTOM_LINE_ITEM };
